export const getLangFromLocale = locale => locale.split('_')[0].toLowerCase();

export const getCountryFromLocale = locale => locale.split('_')[1].toUpperCase();

export const getLocaleFromCountryAndLang = (lang, country) => `${lang.toLowerCase()}_${country}`;
